export function minOrderQuantity(val) {
  return (val && val > 0) || "Minimum item quantity is 1!";
}

export function maxOrderQuantity(val) {
  return (val && val <= 1000) || "Maximum item quantity is 1000!";
}

export function minimumToday(date) {
  let dateFormatted = new Date(date);
  let dateToday = new Date();
  dateToday.setHours(0);
  dateToday.setMinutes(0);
  dateToday.setSeconds(0);
  dateToday.setMilliseconds(0);
  return (
    dateFormatted.getTime() > dateToday.getTime() ||
    "Date must be greater than today"
  );
}
